import { InputWithIcon, FormButton } from "reusableComponents";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { emailIcon } from "assets/icons";
import { useLanguage, useModal } from "context";
import { API_BASE_URL } from 'config';

import styles from "./styles.module.scss";

const ForgotPasswordForm = () => {

const baseUrl = API_BASE_URL;
  const { closeModal } = useModal();
  const { language } = useLanguage();
  const [t] = useTranslation("global");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    setError("");
    setMessage("");
    setLoading(true);

    try {
      const response = await fetch(
     `${baseUrl}users/forgotpwd?lang=${language}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setTimeout(() => closeModal(), 1800);
      } else {
        setError(data.errors?.[0]?.message || "error");
      }
    } catch (err) {
      setError(err?.errors?.[0]?.message || "success");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setError("");
      setEmail("");
      setMessage("");
      setLoading(false);
    };
  }, []);

  return (
    <form onSubmit={handleSubmit} className={styles.forgotPasswordForm}>
      <InputWithIcon
        icon={emailIcon}
        placeholder={t("modal.forgotpwd.email")}
        value={email}
        handleChange={(e) => setEmail(e.target.value)}
      />
      {error && <p className={styles.errorMessage}>{error}</p>}
      {message && <p className={styles.successMessage}>{message}</p>}
      <FormButton
        label={loading ? `${t("buttons.confirm")} . . .` : t("buttons.confirm")}
        type="submit"
        disabled={loading || !email}
      />
    </form>
  );
};

export default ForgotPasswordForm;
